export const PAGE_TYPE_PAGE = 1;
export const PAGE_TYPE_EVENT = 2;